<template>
    <div>
        <card-header title="Edit Task" icon="fa-pencil"/>

        <card-body>
            <task-form :task="task"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteTask"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Task?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button type="is-primary" size="is-small" @click="submit" :disabled="!task.title"><i class="fas fa-check mr-2"></i>Save Task</b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "../../TIER/components/CardHeader";
    import CardBody from "../../TIER/components/CardBody";
    import CardFooter from "../../TIER/components/CardFooter";
    import {client as http} from "../../http_client";
    import TaskForm from "@/cards/tasks/TaskForm";
    import {mapActions} from "vuex";
    import moment from 'moment';

    export default {
        components: {TaskForm, CardFooter, CardBody, CardHeader},
        props: ['card', 'props'],
        data: function () {
            return {
                task: {},
                confirmDelete: false,
                dirty: null
            };
        },
        methods: {
            ...mapActions(['updateTasks']),
            loadTask: function () {
                this.$emit('loading', true);
                http.get('/api/tasks/' + this.props.taskId, {force: true}).then(response => {
                    const task = response.data;
                    // The date input binds YYYY-MM-DD.
                    if (task.due_on) task.due_on = moment(task.due_on).format('YYYY-MM-DD');
                    this.task = task;
                    this.$emit('loading', false);
                });
            },
            submit() {
                this.$emit('loading', true);
                http.put('/api/tasks/' + this.props.taskId, {
                    type: this.task.type,
                    title: this.task.title,
                    description: this.task.description,
                    status: this.task.status,
                    payment: this.task.payment,
                    assigned_id: this.task.assigned_id,
                    due_on: this.task.due_on || null,
                    complete: this.task.complete
                }, {force: true}).then(response => {
                    this.updateTasks();
                    this.$reloadCard('tasks');
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {

                });
            },
            deleteTask() {
                if (this.confirmDelete) {
                    this.$emit('loading', true);

                    http.delete('/api/tasks/' + this.props.taskId).then(response => {
                        this.updateTasks();
                        this.$reloadCard('tasks');
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    }).catch(err => {

                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            }
        },
        watch: {
            'props.taskId': function () {
                this.dirty = null;
                this.loadTask();
            },
            'task': {
                deep: true,
                handler: function () {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this task? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadTask();
        }
    };
</script>
